import React, { useState } from 'react';
import './PublicNav.css';

const SOLUTIONS_GROUPS = [
  {
    label: 'Platform',
    items: [
      { label: 'Agent platform', href: '/solutions/workflow' },
      // Apps — one-click hosted instances of open-source tools (n8n,
      // Grafana, Open WebUI, …). Sits next to "Agent platform" because
      // it's the same product surface (the marketplace + hosting
      // runtime), just packaged as "apps" instead of "workflows".
      { label: 'Apps',           href: '/solutions/apps' },
    ],
  },
  {
    label: 'Recipes',
    items: [
      { label: 'Browser testing', href: '/solutions/browser-testing' },
      { label: 'Code analysis',   href: '/solutions/code-analysis' },
    ],
  },
  {
    label: 'For teams',
    items: [
      { label: 'Self-hosted GitLab / Enterprise', href: '/solutions/firewalled-repos' },
    ],
  },
];

const PublicNav = ({ transparent }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);

  const closeAll = () => {
    setMenuOpen(false);
    setSolutionsOpen(false);
  };

  return (
    <nav className={`public-nav${transparent ? ' public-nav--transparent' : ''}`}>
      <a href="/" className="public-nav-logo">
        <img src="/shaded_cube_logo.svg" alt="Zibby" className="public-nav-logo-img" />
      </a>
      <div className={`public-nav-links ${menuOpen ? 'public-nav-links--open' : ''}`}>
        <a href="/connect" className="public-nav-link" onClick={closeAll}>Get started</a>

        {/* Solutions dropdown */}
        <div
          className={`public-nav-dropdown-wrap ${solutionsOpen ? 'public-nav-dropdown-wrap--open' : ''}`}
          onMouseEnter={() => setSolutionsOpen(true)}
          onMouseLeave={() => setSolutionsOpen(false)}
        >
          <button
            type="button"
            className="public-nav-link public-nav-dropdown-trigger"
            onClick={() => setSolutionsOpen(o => !o)}
            aria-expanded={solutionsOpen}
            aria-haspopup="true"
          >
            Solutions
            <svg width="10" height="6" viewBox="0 0 10 6" className="public-nav-dropdown-chev" aria-hidden="true">
              <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          {solutionsOpen && (
            <>
              {/* Transparent bridge — keeps :hover alive while cursor traverses
                  the gap between trigger and panel. Without it, the panel
                  closes the moment you leave the trigger's bounding box. */}
              <div className="public-nav-dropdown-bridge" aria-hidden="true" />
              <div className="public-nav-dropdown" role="menu">
                {SOLUTIONS_GROUPS.map(group => (
                  <div key={group.label} className="public-nav-dropdown-group">
                    <div className="public-nav-dropdown-label">{group.label}</div>
                    {group.items.map(item => (
                      <a
                        key={item.href}
                        href={item.href}
                        className="public-nav-dropdown-item"
                        onClick={closeAll}
                        role="menuitem"
                      >
                        {item.label}
                      </a>
                    ))}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        <a href="/marketplace" className="public-nav-link" onClick={closeAll}>Marketplace</a>
        <a href="/pricing" className="public-nav-link" onClick={closeAll}>Pricing</a>
        <a href="https://docs.zibby.app" className="public-nav-link" target="_blank" rel="noopener noreferrer" onClick={closeAll}>Documentation</a>
        <a href="mailto:support@zibby.dev" className="public-nav-link public-nav-link--cta" onClick={closeAll}>Contact</a>
      </div>
      <button
        className="public-nav-hamburger"
        onClick={() => setMenuOpen(o => !o)}
        aria-label="Toggle menu"
      >
        <span className={`hamburger-line ${menuOpen ? 'hamburger-open' : ''}`} />
        <span className={`hamburger-line ${menuOpen ? 'hamburger-open' : ''}`} />
        <span className={`hamburger-line ${menuOpen ? 'hamburger-open' : ''}`} />
      </button>
    </nav>
  );
};

export default PublicNav;
